import type { SvgIconComponent } from "@mui/icons-material";
import i18n from "locales/i18n";
import VideocamIcon from "@mui/icons-material/Videocam";
import CallIcon from "@mui/icons-material/Call";
import HandymanIcon from "@mui/icons-material/Handyman";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import BlockIcon from "@mui/icons-material/Block";

const tc = i18n.getFixedT(null, "calendar");

// Single source of truth for the five booking/event types — colors match the
// calendar legend, used for event coloring, the type picker, and the legend.
export type BookingType =
  | "video"
  | "call"
  | "onsite"
  | "inspection"
  | "blocked";

export interface EventTypeMeta {
  id: BookingType;
  label: string;
  color: string;
  icon: SvgIconComponent;
}

// `label` is read at render time, so it follows the language switcher.
const eventType = (
  id: BookingType,
  color: string,
  icon: SvgIconComponent,
): EventTypeMeta => ({
  id,
  get label() {
    return tc(`types.${id}`);
  },
  color,
  icon,
});

export const EVENT_TYPES: EventTypeMeta[] = [
  eventType("video", "#3b82f6", VideocamIcon),
  eventType("call", "#22c55e", CallIcon),
  eventType("onsite", "#f59e0b", HandymanIcon),
  eventType("inspection", "#ef4444", FactCheckIcon),
  eventType("blocked", "#9ca3af", BlockIcon),
];

// Assigned rather than spread, which would freeze each getter's current value.
export const EVENT_TYPE_MAP = Object.fromEntries(
  EVENT_TYPES.map((type) => [type.id, type]),
) as Record<BookingType, EventTypeMeta>;
